import { useState, useEffect, useRef } from "react";

export const useIntersectionObserver = (options = {}) => {
  const [isIntersecting, setIsIntersecting] = useState(false);
  const [hasIntersected, setHasIntersected] = useState(false);
  const elementRef = useRef(null);

  const defaultOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.1,
    triggerOnce: false,
    ...options,
  };

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;

    const observer = new IntersectionObserver(([entry]) => {
      const isElementIntersecting = entry.isIntersecting;
      setIsIntersecting(isElementIntersecting);

      if (isElementIntersecting && !hasIntersected) {
        setHasIntersected(true);
      }

      // If triggerOnce is true, disconnect after first intersection
      if (isElementIntersecting && defaultOptions.triggerOnce) {
        observer.unobserve(element);
      }
    }, defaultOptions);

    observer.observe(element);

    return () => {
      observer.unobserve(element);
    };
  }, [
    defaultOptions.root,
    defaultOptions.rootMargin,
    defaultOptions.threshold,
    defaultOptions.triggerOnce,
    hasIntersected,
  ]);

  return {
    elementRef,
    isIntersecting,
    hasIntersected,
  };
};
